import React from 'react';

import Grid from '@mui/material/Grid2';

import { Box } from '@nerdwallet/currency/components/Box';
import { Button } from '@nerdwallet/currency/components/Button';
import { Text } from '@nerdwallet/currency/components/Text';
import { Title } from '@nerdwallet/currency/components/Title';

import { PlaidStep } from '@components/financial-institutions/plaid-sandbox/plaid-modal-stepper';

import DialogContentWithCloseButton from '@components/mui/dialog-content-with-close-button';
import { usePlaidModalVisibility } from './plaid-modal-visibility-context';

const PlaidFix = ({ handleCloseModal }) => {
  const { setShowPlaidVisibility, showPlaidVisibility } =
    usePlaidModalVisibility();

  const handleRelinkAccount = () => {
    setShowPlaidVisibility({
      show: true,
      plaidStep: PlaidStep.PLAID_RELINK,
      selectedPortal: showPlaidVisibility.selectedPortal,
    });
  };

  const handleUnlinkAccount = () => {
    setShowPlaidVisibility({
      show: true,
      plaidStep: PlaidStep.PLAID_UNLINK,
      selectedPortal: showPlaidVisibility.selectedPortal,
    });
  };

  return (
    <DialogContentWithCloseButton onClose={handleCloseModal}>
      <Box display="flex" flexDirection="column" padding="1">
        <Title size="small">Let’s relink this account</Title>
        <Box marginY="3-half">
          <Text>
            Looks like some wires were crossed. Try relinking your account to
            solve the problem.
          </Text>
        </Box>

        <Grid container spacing={2} direction={{ sm: 'column', md: 'row' }}>
          <Button onClick={handleRelinkAccount} primary>
            relink account
          </Button>
          <Button onClick={handleUnlinkAccount} secondary>
            unlink account
          </Button>
        </Grid>
      </Box>
    </DialogContentWithCloseButton>
  );
};

export default PlaidFix;
